import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useWorkStationInactivityHandler } from "./useWorkStationInactivityHandler";
import { WorkStationRecordsService } from "../../../services/workStationRecordsService";
import { askForAuthCheck } from "../../../redux/authentication/actionCreator";

export function useWorkStationInactivityModal({ handleInactivity, lastActivityDate }) {
  const dispatch = useDispatch();
  const { registerActivity } = useWorkStationInactivityHandler(lastActivityDate, handleInactivity);

  const expireSession = useCallback(() => {
    WorkStationRecordsService.expireRecord().then(() => {
      dispatch(askForAuthCheck());
    });
  }, []);

  return {
    registerActivity,
    expireSession,
  };
}
